<abs-messages>
  <div class="alert b2b-alerts-messages b2b-alerts-success valign-children-middle" *ngIf="showSuccess" tabindex="0"
    [ngClass]="{'d-none':!showSuccess}" [abs-trap-focus-inside-element]="false">
    <div class="alert-success">
      <em class="icon-approval" aria-label="Checkmark" role="img" ab2b-alerts-success></em>
    </div>
    <div id="success-message-id" class="title h3">
      <p *ngFor="let message of messages" class="font13" [innerHTML]="message"></p>
    </div>
    <button type="button" class="close" id="success-msg-close-id" aria-label="Close" #closeBtn tabindex="0"
      (click)="toggle('showSuccess')"></button>
  </div>
</abs-messages>